import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Header from '../header/header';
import { RootState } from '../../../redux/store';

import './main.scss';

const Main = (props) => {
  const [render, setRender] = useState(null);
  const impersonation = useSelector((state: RootState) => state.impersonate);

  useEffect(() => {
    setRender(null);
  }, [impersonation]);
  return (
    <div className={`main-wrapper ${props.className}`}>
      {props.title && (
        <Header
          title={props.title}
          investors={props.investors}
          additionalTitle={props.additionalTitle}
          investorDropdown={props.investorDropdown}
          onInvestorChange={props.onInvestorChange}
        />
      )}
      {props.children}
    </div>
  );
};

export default Main;
